import { createFileRoute, redirect } from '@tanstack/react-router'
import 'mapbox-gl/dist/mapbox-gl.css'
import { allLayerGroups } from '../../features/layers/layers.tsx'
import { MapView } from '../../features/MapView.tsx'
import { urlHash } from '../../router.tsx'
import { useMapState } from '../../states.ts'

export const Route = createFileRoute('/_app/')({
	beforeLoad: ({ cause, search, context: { sub } }) => {
		if (cause === 'stay') {
			const { layers, layerGroups, coordinates, locationId, panel } = search
			useMapState.getState().setMapParams({ layers, layerGroups, coordinates, locationId, panel })
			return
		}
		if (cause !== 'enter') return
		if (search.layers || search.layerGroups || search.coordinates || search.locationId || search.panel) return

		const { mapParams, viewState } = useMapState.getState()
		const hash = viewState ? urlHash.format(viewState) : undefined
		if (mapParams && Object.values(mapParams).some(Boolean)) {
			throw redirect({ to: '/', search: { ...search, ...mapParams }, hash })
		}
		if (sub.layerGroups.includes('severe') && !mapParams && !viewState) {
			const defaultParams = { layerGroups: ['severe'], layers: allLayerGroups.severe.defaultLayers }
			useMapState.getState().setMapParams(defaultParams)
			throw redirect({
				to: '/',
				search: { ...search, ...defaultParams },
				hash,
			})
		}
	},
	component: MapView,
})
